import { downloadBffFile } from "../../../../common/download/downloadBffFile";
import { sanitizeFilename } from "../../../../common/utils/sanitizeUtils";

export const downloadProtocolVersion = ({ downloadUrl, fileName }: { downloadUrl: string; fileName: string }) =>
  downloadBffFile(downloadUrl, sanitizeFilename(`${fileName}.pdf`));
